import { bodySegments } from './mentions';

/** A message as text and mention chips: React text nodes only, never HTML (spec F.1: plain text). */
export function CommentBody({ body, names }: { body: string; names: ReadonlyMap<string, string> }) {
  return (
    <p className="whitespace-pre-wrap break-words font-sans text-sm text-fg">
      {bodySegments(body, names).map((s, i) =>
        'text' in s ? (
          <span key={i}>{s.text}</span>
        ) : (
          <span key={i} data-mention={s.mention} className="rounded bg-accent/10 px-0.5 font-medium text-accent-text">
            @{s.name ?? '?'}
          </span>
        ),
      )}
    </p>
  );
}
